export const setQuestionList='question manage set question list';
export const setShopcar='question manage set set shopcar';
export const setQuestionListShopcar='question manage set question list shop car';


export const setTypeList='question manage set question set type list';
export const setAssistList='question manage set question set assist list';
export const setTreeList='question manage set question set tree  list';
export const setExpandedKeys='question manage set question set Expanded Keys';
export const setDefaultAssistList='question manage set question set set DefaultAssistList ';
export const setSelectedKeys='question manage set question set set SelectedKeys';




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/actionType.js